import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Button, Container, Header, Segment } from 'semantic-ui-react';
import Auth from '../../stores/Auth';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class Terms extends React.Component {
	props: {
		auth?: Auth,
		history?: History
	};

	render() {
		const { history, auth } = this.props;
		const role = auth.user.role;
		return (
			<Segment basic>
				<Container text textAlign="justified">
					<Header as="h1" textAlign="center">
						Script Approval Management (SAM)
					</Header>
					<Header as="h2" textAlign="center">
						Terms and Conditions
					</Header>
					<Header as="h3">About these Terms and Conditions</Header>
					<p>In these Terms and Conditions:</p>

					<ul type="none">
						<li>
							"you" or "your" is a reference to the End User agreeing to these Terms and Conditions
							and all parties acting on the End User’s behalf;
						</li>
						<li style={{ marginTop: '15px' }}>
							"we", "our" or "us" is a reference to Seekwell Pty Ltd (Seekwell).
						</li>
					</ul>
					<p>
						These Terms and Conditions govern your registration to use Script Approval Manager (SAM)
						and your access to and use of SAM as a registered and approved End User of SAM.
					</p>

					<Header as="h3">What is SAM?</Header>

					<p>
						SAM is a software service provided by Seekwell that interacts electronically with the
						Pharmaceutical Benefits Scheme (PBS) Authorities System, for the purpose of submitting
						immediate authority requests for continuing script approvals.
					</p>
					<p>
						SAM allows registered and approved End Users, who also have an approved and/or delegated
						authority to use the Provider Digital Access (PRODA) service provided by Services
						Australia, to submit immediate authority requests to the PBS.
					</p>
					<p>
						(Please note that SAM can only be used for the submission of immediate authority
						requests for continuing script approvals).
					</p>
					<p>
						SAM supports two types of End Users, being a Prescriber End User (Prescriber) and a
						Delegated Authority End User (Delegated Authority). The two types of End Users have
						different responsibilities in SAM. A Prescriber can delegate one or more Delegated
						Authority the authority to input scripts requiring approval in SAM, on behalf of the
						Prescriber. Once a Delegated Authority has entered a script requiring approval into SAM,
						the Prescriber reviews and provides their approval for the submission of the script to
						the PBS for approval.
					</p>

					<p>
						<strong>As an End User, you agree:</strong>
					</p>

					<ul type="disc">
						<li>
							to conduct transactions electronically with us and Services Australia using your SAM
							Credentials;
						</li>
						<li>to be bound by these Terms and Conditions every time you use SAM;</li>
						<li>
							that access to SAM is provided to you by us (and our third-party suppliers) in
							consideration of your agreement to these Terms and Conditions and your use constitutes
							acceptance of these Terms and Conditions. If you do not agree with these Terms and
							Conditions, please do not use, install, modify or redistribute SAM or use your SAM
							Credential to access SAM.
						</li>
					</ul>

					<Header as="h3">Changes to Terms and Conditions</Header>

					<ul type="disc">
						<li>
							that we may change or add to these Terms and Conditions at any time, by giving you
							notice, which may be provided electronically;
						</li>
						<li>
							{' '}
							that if you do not agree to the amendments, you should cease to use SAM and remove SAM
							from your Device;
						</li>
						<li>
							{' '}
							that if you access or use SAM after you have been notified of a change or addition to
							these Terms and Conditions, you will be taken to have agreed to that change or
							addition in respect of all access to and use of SAM after that date; and
						</li>
						<li>
							{' '}
							that these Terms and Conditions may not be changed orally or by conduct by any person.
						</li>
					</ul>

					<Header as="h3">Compliance</Header>

					<p>You agree to comply with these Terms and Conditions in relation to your use of SAM.</p>

					<p>
						When you use SAM to conduct electronic transactions with Services Australia, you agree
						that:
					</p>
					<ul type="disc">
						<li>
							you will comply with these Terms and Conditions when conducting those transactions;
							and
						</li>
						<li>
							those transactions will be governed by the terms of use that apply to PRODA on which
							those transactions are conducted, but those terms of use do not affect your obligation
							to comply with the SAM Terms and Conditions.
						</li>
					</ul>

					<p>
						If any part of these Terms and Conditions are illegal or unenforceable, we may remove
						that part from these Terms and Conditions and the remaining parts will continue in
						force.
					</p>
					<p>
						Failure to take reasonable steps to protect information held in SAM from misuse,
						interference, and loss, and from unauthorised access, modification or disclosure is a
						serious offence under the Privacy Act 1988 (Cth).
					</p>

					<Header as="h3">
						Accuracy of information and representations and false or misleading information
					</Header>
					<p>You agree:</p>
					<ul type="disc">
						<li>
							that all information you provide, and representations you make, to us are true,
							complete and accurate;
						</li>
						<li>
							that we are not liable for the accuracy of any information provided, or
							representations made, by you or for any action taken by us in reliance on that
							information or those representations where you do not provide information that is true
							and correct in all respects;
						</li>
						<li>
							to notify us promptly in the event that you consider any information provided, or
							representation made by you:
							<ul>
								<li>
									needs to be updated, including your email address or phone number as held in our
									records; or
								</li>
								<li>is or may be incorrect or misleading.</li>
							</ul>
						</li>
					</ul>

					<Header as="h3">Management of your Personal Information</Header>
					<p>
						You understand and agree that we may collect, use and disclose your personal information
						as set out in the Script Approval Management Privacy Policy.
					</p>

					<Header as="h3">Terms of use of the System</Header>

					<p>You agree:</p>
					<ul type="disc">
						<li>
							subject to any law to the contrary, SAM is provided on an "as is" and "as available"
							basis;
						</li>
						<li>
							we may monitor your access to SAM for the purpose of ensuring that all licences are
							current and valid (for e.g., disabling accounts for users who no longer require them)
						</li>
						<li>
							that you are responsible for your use of SAM, including any information you provide to
							us, and will use SAM in compliance with all applicable laws;
						</li>
						<li>
							that we will use reasonable efforts to protect information submitted by you in
							connection with SAM
						</li>
						<li>
							to only access information in SAM about a person with the person’s consent and for
							script submission purposes only.
						</li>
					</ul>

					<Header as="h3">Terms of use of SAM Multifactor Authentication (MFA)</Header>

					<p>
						To log in to SAM, you are required to complete a Multifactor Authentication process.
						After initial log in with your personal credentials, you will receive an SMS message,
						which contains a code, and you are required to enter this code in the SAM log in screen,
						in order to access the system. You are not required to install any additional software
						application for this process to work – standard SMS messaging functionality only is
						required.
					</p>

					<p>
						Subject to any law to the contrary, the SAM Multifactor Authentication service is
						provided on an "as is" and “as available” basis. We do not give any warranty of any
						kind, express or implied, or make any representation in relation to all or any part of
						MFA, as to its or their availability, performance, security or fitness for a particular
						purpose and in respect of the availability, accuracy, completeness or correctness of any
						information, and to the full extent permitted by law all statutory warranties are
						excluded.
					</p>

					<p>
						To the extent permitted by law, we are not liable to you for any damage or loss arising
						in connection with your access to SAM, either directly or through a third-party provider
						including via Multifactor Authentication. We will not be responsible for any fees
						charged by any third-party provider you use to access SAM.
					</p>

					<Header as="h3">Intellectual Property</Header>
					<p>
						SAM and the information contained within SAM is subject to intellectual property rights
						including copyright. You must not use, reproduce, amend or alter intellectual property
						rights in SAM.
					</p>

					<p>
						Unless stated otherwise, the content (including text, graphics, logos, icons, images,
						video and audio clips and any other form of information or content and design elements)
						is owned by Seekwell. Your use of SAM is by way of a non-exclusive licence as set out in
						these Terms and Conditions and in no way transfers or assigns ownership in any
						intellectual property rights (including copyright) to you.
					</p>

					<p>
						You are liable for breaches of intellectual property caused by your use of SAM other
						than in accordance with these Terms and Conditions.
					</p>

					<Header as="h3">Security</Header>

					<p>You agree:</p>

					<ul type="disc">
						<li>
							to keep your SAM Credential, your user identification and passwords for SAM and any
							other security details for your access to SAM, (together, your "Secure Access
							Details") confidential and secure at all times.
						</li>
						<li>
							to take all necessary precautions to prevent loss, disclosure, modification, or
							unauthorised use of your Secure Access Details;
						</li>
						<li>to change your System password(s) regularly;</li>
						<li>
							to not permit any other person to use your Secure Access Details except in accordance
							with these Terms and Conditions;
						</li>
						<li>to comply with security requirements or instructions we provide to you;</li>
						<li>
							to not copy, extract, keep, publish, or share information you obtain through SAM
							outside the course of your duties as, or on behalf of, a Provider;
						</li>
						<li>
							to not knowingly introduce malicious code to SAM or use malicious software (including
							bots and scraper tools) to access, monitor or copy SAM or its contents; and
						</li>
					</ul>

					<p>
						Regardless of which device you use to access SAM, you will be responsible for all access
						to, and use of, SAM with your user identification and password.
					</p>

					<Header as="h3">Notification to us</Header>

					<p>
						You agree to immediately notify us via the Contact Details provided below, in the event:
					</p>

					<ul type="disc">
						<li>of the possible loss or theft of any of your Secure Access Details;</li>
						<li>
							of the possible loss or theft of your Device where the SAM mobile application is
							installed on your device;
						</li>
						<li>
							that you consider or suspect that any of your Secure Access Details are compromised in
							any way;
						</li>
						<li>
							that you become aware of or suspect that an unauthorised person:
							<ul>
								<li>has accessed SAM; or</li>
								<li>
									has submitted claims, forms or other documentation to us using your Secure Access
									Details; or
								</li>
								<li>
									that you become aware of or suspect any identity theft, impersonation or any other
									fraudulent activity in connection with your Secure Access Details.
								</li>
							</ul>
						</li>
					</ul>

					<Header as="h3">Accessibility</Header>

					<p>You agree:</p>

					<ul type="disc">
						<li>
							that we may from time to time change our technical requirements in relation to the use
							of SAM, which may require you to:
							<ul>
								<li>change your Secure Access Details; or</li>
								<li>upgrade your software / browser; and</li>
							</ul>
						</li>
						<li>
							that your access to SAM depends on services provided by telecommunications and
							internet service providers, and other external factors, and that we cannot guarantee
							the availability of SAM.
						</li>
					</ul>

					<Header as="h3">Changes to the System</Header>
					<p>You agree:</p>

					<ul type="disc">
						<li>that we may make changes to SAM at any time, with or without notice to you; and</li>
						<li>
							that we may notify you of changes to SAM through information and notices available to
							you when you access SAM.
						</li>
					</ul>

					<Header as="h3">Liability</Header>
					<p>You agree:</p>

					<ul type="disc">
						<li>
							that Seekwell is not responsible for any damage to your computer, systems, software or
							Device caused by any Harmful Code, corruption, attack, interference or other security
							intrusion; and
						</li>
						<li>
							that to the maximum extent permitted by law:
							<ul>
								<li>
									the MFA is provided on an 'as is' and 'as available' basis. We make no
									representations or warranties that MFA will be free from loss, corruption, attack,
									Harmful Code, interference or other security intrusion, or will be uninterrupted,
									error free, fit for purpose, that any defects with MFA will be rectified or that
									MFA will not have unintended effects on the operation of your Device; and
								</li>
								<li>
									we (and our employees and agents) and any relevant Other Agency exclude any and
									all liability we (or they) may have at law, including in contract, tort (including
									negligence), under statute or otherwise, to you or anyone acting on your behalf
									for any claims, costs, losses, liabilities, expenses or damage ("Losses"), whether
									direct, indirect or consequential, incidental, punitive, special or otherwise
									(including, without limitation, costs concerning loss of data, communication
									costs, support costs, software acquisition or other procurement of substitute
									goods or services costs, loss of goodwill, work stoppage, computer failure or
									malfunction, or any other commercial Losses including Losses associated with SAM
									being from time to time inoperative or inaccessible), arising from or in
									connection with:
									<ul type="disc">
										<li>
											your access to or use of or other dealings in, or anyone on your behalf's
											access to or use of or other dealings in, SAM;
										</li>
										<li>
											your access to or use of or other dealings in, or anyone on your behalf's
											access to or use of or other dealings in, the MFA;
										</li>
										<li>
											your use of, or anyone on your behalf's use of, your Secure Access Details in
											relation to SAM, or the systems of Other Agencies;
										</li>
										<li>errors or omissions in content;</li>
										<li>incorrect information provided to you;</li>
										<li>your failure to comply with these Terms and Conditions;</li>
										<li>our termination or suspension or your access to SAM;</li>
										<li>
											termination or suspension of your access to a system of an Other Agency using
											your Secure Access Details;
										</li>
										<li>your loss or disclosure of your Secure Access Details;</li>
										<li>the performance of SAM or any part of SAM; and</li>
										<li>SAM being altered or modified or not being available.</li>
									</ul>
								</li>
							</ul>
						</li>
					</ul>

					<p>
						You agree to indemnify, defend, and hold us harmless for any liability incurred by, or
						claims asserted against, us.
					</p>

					<p>
						You agree that by approving a particular version of a software product, we are not
						representing that the product is suitable for any purpose or that the product meets any
						quality standards.
					</p>

					<p>
						We will use reasonable endeavours to protect information submitted by you in connection
						with SAM, but you agree that your submission of such information is at your sole risk,
						and in accordance with the details listed above we, and any relevant Other Agency,
						disclaim any and all liability to you for any loss or liability relating to such
						information in any way.
					</p>

					<Header as="h3"> Restriction, suspension and termination</Header>

					<p>You agree:</p>

					<ul type="disc">
						<li>
							that we may at any time, at our absolute discretion, restrict, suspend or terminate
							these Terms and Conditions, your access to SAM, your use of SAM, including:
							<ul>
								<li>
									because we reasonably believe that you have breached these Terms and Conditions;
								</li>
								<li>
									because we reasonably believe that your Secure Access Details have been used to
									perform an unauthorised transaction (including an unauthorised transaction with
									Services Australia);
								</li>
								<li>because you are no longer eligible to access SAM;</li>
								<li>because Services Australia has requested us to do so; or</li>
								<li>for any other reason;</li>
							</ul>
						</li>
						<li>
							that either party may terminate these Terms and Conditions at any time You understand
							that you will not be able to use SAM after termination; and
						</li>
						<li>
							that if these Terms and Conditions are terminated, your obligations under these Terms
							and Conditions will continue in respect of any use of SAM before the Date of
							Termination, and our rights to recover any debt owing will also continue.
						</li>
					</ul>

					<Header as="h3">Jurisdiction</Header>
					<p>
						These Terms and Conditions are issued under and are to be construed in accordance with
						the laws in force from time to time in New South Wales. All parties submit to the
						exclusive jurisdiction of the courts of New South Wales and courts of appeal from them.
						Neither party will object to the exercise of jurisdiction by those courts on any basis.
					</p>

					<Header as="h3">Rule of Construction</Header>
					<p>
						No rule of construction will apply in the interpretation of these Terms and Conditions
						to the disadvantage of us on the basis that that party put forward or drafted these
						Terms and Conditions or any part of these Terms and Conditions.
					</p>

					<Header as="h3">Contact Information</Header>
					<p>
						If you have any questions about these Terms and Conditions, wish to make a complaint
						with respect to SAM, or need further information, please contact us:
					</p>

					<p>
						Via email at <a href="mailto:info@seekwell.com.au">info@seekwell.com.au</a>
					</p>

					<Header as="h3">Declaration</Header>
					<p>
						By beginning the registration process, you acknowledge that you accept these Terms and
						Conditions, and you declare that:
					</p>

					<ul type="disc">
						<li>
							you have the authority to agree to and submit to these Terms and Conditions and to
							commence the registration process;
						</li>
						<li>the information provided by you is true, complete and correct;</li>
						<li>
							you have read and understood the Terms and Conditions; and you are the individual that
							you assert to be.
						</li>
					</ul>

					<Button
						primary
						floated="right"
						onClick={() => {
							history.push(`/app/${role}?s=1`);
						}}
					>
						Back
					</Button>
					<br />
					<br />
				</Container>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Terms/index.js